<template>
  <div class="logged-out">
    <div class="d-flex justify-content-center align-items-center h-100">
      <b-container fluid>
        <b-row>
          <b-col
            md="8"
            offset-md="2"
          >
            <div class="logged-out-content">
              <slot name="authentication-content" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
  // TODO should be moved in src/components
  export default {
    name: 'AuthenticationLayoutComponent',
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .logged-out {
    height: 100vh;
    background: {
      image: url('/static/img/background.jpg');
      position: center;
      size: cover;
      repeat: no-repeat;
    }
  }
</style>
